export default __webpack_public_path__ + "static/media/GAVResortsBranca.1e84e267.svg";